<template>
  <v-app>
    <v-app-bar absolute>
      <v-row justify="space-between">
        <v-col class="d-flex justify-start">
          <v-btn text class="text-h5 font-weight-black">Spark Studio</v-btn>
        </v-col>
        <v-col class="d-flex justify-center"> </v-col>
      </v-row>
    </v-app-bar>
    <v-main>
      <router-view></router-view>
    </v-main>
    <v-footer app> </v-footer>
  </v-app>
</template>

<script>
export default {
  name: "deflayout",
};
</script>

<style></style>
